import TableOfContents from "./TableOfContents";

export default function DocsPageFrame({ children, sections }) {
  return (
    <div className="docs-page-frame">
      <div className="docs-reading-column">
        <article className="docs-content">{children}</article>
      </div>
      {sections ? (
        <aside className="docs-toc-rail">
          <TableOfContents sections={sections} />
        </aside>
      ) : null}
    </div>
  );
}
